import React, { useState, useEffect, useRef } from 'react';
import Chart from "react-google-charts";

const Tags = (props) => {
    const { showCharts } = props;
    const [tagsData, setTagsData] = useState([['Tag', 'Tickets']]);
    const [slicesColors, setSlicesColors] = useState({});
    const isMountedRef = useRef(true);
    const [showChart, setShowChart] = useState(false);

    useEffect(() => {
        if (!showCharts) return;
        isMountedRef.current = true;
        const chartTimer = setTimeout(() => {
            if (isMountedRef.current) setShowChart(true);
        }, 0);
        return () => {
            isMountedRef.current = false;
            clearTimeout(chartTimer);
        };
    }, [showCharts]);

    useEffect(() => {
        let newTagsData = [['Tag', 'Tickets']];
        let newSlicesColors = {};
        if (props.tags.tags !== undefined) {
            props.tags.tags.forEach(item => newTagsData.push([item.name, item.tickets_count]));
            props.tags.tags.forEach((item, index) => {
                newSlicesColors[index] = { color: item.color };
            });
        }
        if (isMountedRef.current) {
            setTagsData(newTagsData);
            setSlicesColors(newSlicesColors);
        }
    }, [props.tags]);

    return(
        <div className="header-panel-dashboard bg-white after-top">
            <div className="dashboard-box-chart">
                {showCharts !== true ? <div style={{ height: 270, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div>Loading Chart</div></div> : showChart && <Chart
                    width={'100%'}
                    height={270}
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={tagsData}
                    fontName={'Montserrat'}
                    options={{
                        title: 'Tags Tickets',
                        titleTextStyle: {color: '#25313C', fontSize: 14, bold: false, fontName: 'Poppins'},
                        slices: slicesColors,
                        chartArea: {
                            left: 30,
                            right: 30,
                            top: 25,
                            bottom: 10
                        },
                    }}
                />}
            </div>
        </div>
    )
}
export default Tags
